/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { GridGuideServiceRepositoryImpl, GridGuideServiceRepositoryImplV2 } from '../impls';
import { IGridGuideService } from '../interfaces';
import { TGridGuideRow, TOneLineGuideRow } from '../types';
import { TServicesParams } from '../types/TServicesParams';
import { DateTime } from '../utils';

export class GridGuideService implements IGridGuideService {
    private readonly oGridGuideServiceRepository: GridGuideServiceRepositoryImpl;

    private readonly oGridGuideServiceRepositoryV2: GridGuideServiceRepositoryImplV2;

    public constructor(params: TServicesParams) {
        this.oGridGuideServiceRepository = new GridGuideServiceRepositoryImpl(params);
        this.oGridGuideServiceRepositoryV2 = new GridGuideServiceRepositoryImplV2(params);
    }

    public async fetchProgramMetadata(
        stationId: string[],
        startTime: DateTime,
        endTime: DateTime,
    ): Promise<TGridGuideRow[]> {
        return this.oGridGuideServiceRepository.fetchProgramMetadata(stationId, startTime, endTime);
    }

    public async fetchProgramMetadataV2(
        stationId: string[],
        startTime: DateTime,
        endTime: DateTime,
    ): Promise<TGridGuideRow[]> {
        return this.oGridGuideServiceRepositoryV2.fetchProgramMetadata(
            stationId,
            startTime,
            endTime,
        );
    }

    public async fetchOneLineGuideRowMetadata(
        stationId: string,
        anchorTime: DateTime,
        count: number,
        offset: number,
        pastMode: boolean,
        networkCallId?: number,
    ): Promise<TOneLineGuideRow> {
        return this.oGridGuideServiceRepository.fetchOneLineGuideRowMetadata(
            stationId,
            anchorTime,
            count,
            offset,
            pastMode,
            networkCallId,
        );
    }

    public async fetchOneLineGuideRowMetadataV2(
        stationId: string,
        anchorTime: DateTime,
        count: number,
        offset: number,
        pastMode: boolean,
        networkCallId?: number,
    ): Promise<TOneLineGuideRow> {
        return this.oGridGuideServiceRepositoryV2.fetchOneLineGuideRowMetadata(
            stationId,
            anchorTime,
            count,
            offset,
            pastMode,
            networkCallId,
        );
    }
}
